import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './Paragraph.module.scss.js';

/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Typography/Paragraph.tsx)
 */
const P1 = forwardRef((props, ref) => {
    const { bold, children, className, ...otherProps } = props;
    const { componentTestLabel } = getTestLabels('P1');
    return (jsx("p", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames([
            style['z-p1'],
            { 'z-p1--bold': bold },
            className,
        ]), children: children }));
});
P1.displayName = 'P1';
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Typography/Paragraph.tsx)
 */
const P2 = forwardRef((props, ref) => {
    const { bold, children, className, ...otherProps } = props;
    const { componentTestLabel } = getTestLabels('P2');
    return (jsx("p", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames([
            style['z-p2'],
            { 'z-p2--bold': bold },
            className,
        ]), children: children }));
});
P2.displayName = 'P2';
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Typography/Paragraph.tsx)
 */
const P3 = forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;
    const { componentTestLabel } = getTestLabels('P3');
    return (jsx("p", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-p3'], className), children: children }));
});
P3.displayName = 'P3';

export { P1, P2, P3 };
//# sourceMappingURL=Paragraph.js.map
